<template>
  <div class="procard_wrap">
     
    
    <div class="procard_content" >
      <div class="content_left">
        <div class="left_tit">
          联系我们
        </div>
        <ul class="contactUl">
						<li>
							<span>
								地址:
							</span>
							<span>
								郑州市经济开发区航海东路1511号
							</span>
						</li>
						<li>
							<span>
								电话、传真:
							</span>
							<span>
								0371-65959666
							</span>
						</li>
						<li>
							<span>
								电子邮箱:
							</span>
							<span>
								hngwjt@zygangwu.com
							</span>
						</li>
					</ul>
      
        
      </div>
      <div class="content_right" >
        <a target="_blank" class="mapA" href="https://map.baidu.com/poi/%E6%B2%B3%E5%8D%97%E4%B8%AD%E8%B1%AB%E5%9B%BD%E9%99%85%E6%B8%AF%E5%8A%A1%E9%9B%86%E5%9B%A2%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8-%E5%8C%97%E9%97%A8/@12666156.10877015,4102134.7750731,19z?uid=a667f5b76a70509b28201ac4&ugc_type=3&ugc_ver=1&device_ratio=1&compat=1&pcevaname=pc4.1&querytype=detailConInfo&da_src=shareurl">
          <img src="../../assets/w/img3/gaikuang/guaikuang-map.jpg" alt="" :style="{ width: 'auto', height: '90%', objectFit: 'cover' }" />
        </a>
      </div>
    </div>
 

     
    
  </div>
</template>

<script>


export default {
  components: {
  
  },
  data() {
    return {
     
    
      
    }
  },
  props: {
   
  },
  methods: {
   
  },
}
</script>

<style lang="scss" scoped>
.procard_wrap {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.02) inset;
  @media screen and (max-width: 768px) {
    width: 95%;
    background: #f7f7f7;
  }
  .procard_btn {
    width: 100%;
    display: flex;
    .procard_item {
      flex: 1;
      height: 80px;
      background: #f5f5f5;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 20px;
      position: relative;
      cursor: pointer;
      @media screen and (max-width: 768px) {
        height: 60px;
        text-align: center;
        font-size: 12px;
      }
    }
    .active {
      color: #fff;
      background: #2091d3;
      font-weight: bold;
      &::before {
        // content: '▲';
        position: absolute;
        color: #2091d3;
        font-size: 40px;
        transform: rotateX(180deg);
        bottom: -27px;
      }
    }
  }
  .procard_content {
    width: 100%;
    display: flex;
    padding: 30px 0;
    // justify-content: center;
    @media screen and (max-width: 768px) {
      flex-direction: column;
    }
    .content_right {
      // background: blue;
      width:59%;
      
      
       @media screen and (max-width: 768px) {
        width: 100%;
      }
      .mapA{
        width: 100%;
        height: 100%;
        display:block;
        // border:1px solid #999999;
        cursor:pointer;
        padding:1rem;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .mapA:hover{
              border:1px solid #ebecec
      }
      
     
    }
    .content_left {
      width: 30%;
      margin-left: 5%;
      // background: red;
      padding:0 3em;
      font-size: 1rem;
      line-height: 3rem;
      @media screen and (max-width: 768px) {
        width: 100%;
      }
      text-align: left;
      .left_tit{
        font-size: 2rem;
        line-height: 3rem;
        padding-top:1.5rem;
      }
      .contactUl{
        width: 100%;
        padding-top:1.5rem;
        li{
          list-style: none;
          line-height:3rem;
          font-size:1rem;
          @media screen and (max-width: 768px) {
            font-size:1rem;
            line-height:2rem;
          }
        }
      }
      .left_txt{
        text-indent: 2em;
        line-height:2em;
        @media screen and (max-width: 768px) {
          line-height:3em;
          text-align: left;
      }
      }
    }
  }
}


</style>